import { SoftDelete } from './SoftDelete';

export enum ElementType {
  POINT = 'POINT',
  LINESTRING = 'LINESTRING',
  POLYGON = 'POLYGON',
  ROUTE = 'ROUTE',
  CIRCLE = 'CIRCLE',
  SAM = 'SAM',
  CHAT_SAM = 'CHAT_SAM',

  MARKER = 'MARKER',
  HIGHLIGHTER = 'HIGHLIGHTER',
  BLOCK_TEXT = 'BLOCK_TEXT',
  NOTE = 'NOTE',
  LINK = 'LINK',
  VIDEO = 'VIDEO',
  NONE = 'NONE',
}

export interface Element_Base extends SoftDelete {
  uuid: string;
  name: string;
  description: string;
  type: ElementType;

  properties: string; // json
  metadata: string; // json
  geom: any; // postgis geometry

  project_id: number;
}

export interface Element_Point_StyleMetadata {
  icon?: string;
  showLabel?: boolean;
  color?: string;
  size?: number;
  frame?: 'circle' | 'square' | '';
}

export const Element_Point_StyleMetadata_ModelUtil = {
  normalize: (style: Element_Point_StyleMetadata) => {
    return {
      icon: style.icon || 'dot',
      showLabel: style.showLabel || false,
      color: style.color || '#ff0000',
      size: style.size || 1,
      frame: style.frame || 'circle',
    };
  },
};

export interface Element_LineString_StyleMetadata {
  color?: string;
  opacity?: number;
  strokeWidth?: number;
  lineStyle?: 'solid' | 'dashed' | 'dotted';
  showLabel?: boolean;
}

export const Element_LineString_StyleMetadata_ModelUtil = {
  normalize: (style: Element_LineString_StyleMetadata) => {
    return {
      color: style.color || '#ff0000',
      opacity: style.opacity || 1,
      strokeWidth: style.strokeWidth || 1,
      lineStyle: style.lineStyle || 'solid',
      showLabel: style.showLabel || false,
    };
  },
};

export interface Element_Polygon_StyleMetadata {
  color?: string;
  opacity?: number;
  strokeColor?: string;
  strokeWidth?: number;
  strokeOpacity?: number;
  showLabel?: boolean;
}

export const Element_Polygon_StyleMetadata_ModelUtil = {
  normalize: (style: Element_Polygon_StyleMetadata) => {
    return {
      color: style.color || '#ff0000',
      opacity: style.opacity || 0.25,
      strokeColor: style.strokeColor || '#ff0000',
      strokeWidth: style.strokeWidth || 1,
      strokeOpacity: style.strokeOpacity || 1,
      showLabel: style.showLabel || false,
    };
  },
};
